import React from "react";
import useReveal from "../../hooks/useReveal";
import "./styling/Reveal.css";

/**
 * MaskReveal — a heading that wipes up from behind a mask (clip-path + rise)
 * the first time it scrolls into view. Renders the tag you ask for (default
 * `h2`) and forwards all extra props, so it can replace an existing heading
 * element directly and keep its classes (e.g. gradient `section-heading`).
 *
 * Companion to {@link Reveal} (which does a plain fade/slide); use this for the
 * more pronounced heading entrance. Respects `prefers-reduced-motion` via
 * {@link useReveal} and the `.mask-reveal` stylesheet.
 *
 * @param {Object} props
 * @param {React.ElementType} [props.as="h2"] Element/tag to render.
 * @param {string} [props.className] Extra classes (e.g. "section-heading").
 */
const MaskReveal = ({ as: Tag = "h2", className = "", children, ...rest }) => {
  const [ref, isVisible] = useReveal();

  // Outer wrapper is what IntersectionObserver watches (never clipped to zero
  // area); the inner heading is what slides up behind the overflow mask. The
  // heading keeps its own class (e.g. gradient `section-heading`) and props.
  return (
    <div ref={ref} className={`mask-reveal${isVisible ? " is-visible" : ""}`}>
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    </div>
  );
};

export default MaskReveal;
